import actions from "./actions";
import mutations from "./mutations";

const state = {
  id_language: null,
  user_id: null,
  temp_language: [],
  res_languageByID: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
